import React from "react";
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

// 화면 pdf 다운로드 기능 관련
import html2Pdf from 'html2pdf.js';
import { useRef } from 'react';


import mainBg from "../../assets/img/bg-ai-03.jpg";
import aiImg from "../../assets/img/ai-WISbot.png";
import aiIcon01 from "../../assets/img/icon-ai09.png";
import aiIcon02 from "../../assets/img/icon-ai10.png";
import aiIcon03 from "../../assets/img/icon-ai06.png";
import aiIcon04 from "../../assets/img/icon-ai11.png";
import fwImg from "../../assets/img/fw-wisbot.png";

function WISbot() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';


  const contentRef = useRef(null);

  //이미지 클릭
   const imgClick = () => {
    const img = new Image();
    img.src = fwImg;

    img.onload = () => {
      // 이미지 실제 원본 크기 가져오기
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;
      
      // 창 크기를 1200px로 고정하고 반응형으로 조정, 높이는 이미지 비율에 맞춤
      const w = Math.min(1200, window.innerWidth * 0.94);
      const aspectRatio = imgHeight / imgWidth;
      const h = w * aspectRatio;

      // 창을 현재 모니터 중앙에 위치시키기 (듀얼모니터 환경 고려)
      const currentScreenLeft = window.screen.availLeft || 0;
      const currentScreenWidth = window.screen.availWidth;
      const left = currentScreenLeft + (currentScreenWidth - w) / 2;
      const top = (window.screen.height - h) / 2;

      // HTML 페이지를 만들어서 이미지와 파비콘을 함께 표시
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="ko">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>WISbot 프레임워크</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
              overflow: auto;
            }
            .image-container {
              width: 100%;
              height: 100%;
              text-align: center;
              padding: 0;
              overflow: visible;
            }
            .image-container img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
              transition: transform 0.3s ease;
              transform-origin: top left;
            }
            .image-container img.zoomed {
              cursor: zoom-out;
            }
          </style>
          <script>
            function toggleZoom(img) {
              if (img.classList.contains('zoomed')) {
                // 축소: 원본 크기로
                img.style.transform = 'scale(1.0)';
                img.classList.remove('zoomed');
              } else {
                // 확대: 1.5배 또는 이미지 원본 크기 제한
                const imgNaturalWidth = ${imgWidth};
                const containerWidth = ${w};
                const scale1_5 = 1.5;
                const scale1_5Width = containerWidth * scale1_5;
                
                // 1.5배 크기가 이미지 원본보다 크면 원본 크기로, 작으면 1.5배로
                let finalScale;
                if (scale1_5Width > imgNaturalWidth) {
                  finalScale = imgNaturalWidth / containerWidth;
                } else {
                  finalScale = scale1_5;
                }
                
                img.style.transform = 'scale(' + finalScale + ')';
                img.classList.add('zoomed');
              }
            }
          </script>
        </head>
        <body>
          <div class="image-container">
            <img src="${fwImg}" alt="WISaicc 프레임워크" onclick="toggleZoom(this)" />
          </div>
        </body>
        </html>
      `;

      // 새 창 열기 - 이미지 비율에 맞춘 높이로
      const newWindow = window.open(
        "",
        "_blank",
        `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no`
      );

      if (newWindow) {
        newWindow.document.write(htmlContent);
        newWindow.document.close();
      }
    };
  };

  //파일다운로드
    const downloadFile = async () => {
    const response = await fetch("/download/brochure");
    const blob = await response.blob();
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "위피아_AI솔루션.pdf";
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  // pdf 다운로드 기능 테스트
  // pagebreak mode : legacy , css, avoid-all
  const pdfDownload = function () {
		const options = {
			// margin: [10, 10, 10, 10],               
			margin: [10, 0, 10, 0],      
			filename: '테스트',                     
			pagebreak: { mode: 'avoid-all' },    
			image: { type: 'jpeg', quality: 1 },    
			html2canvas: {
				useCORS: true,                           
				scrollY: 0,                                      
				// scale: 1,                                         
				// dpi: 300,
				letterRendering: false,
				allowTaint: false,
        // width: 1500,                     
			},
      jsPDF: {
        orientation: 'portrait',        
        // orientation: 'landscape',               
        unit: 'mm',
        format: 'a4'                                      
      },
    };

    const content = contentRef.current;

    console.log(content.width);

    html2Pdf().set(options).from(content).toContainer().save();

  };

    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
            <span className="ko">기업 맞춤형 RAG 기반 생성형 챗봇 솔루션</span>
						<h2>WISbot</h2>
						<p>기업의 데이터를 실시간으로 참조하고, 신뢰성 높은 맞춤형 답변을 제공하는 AI 챗봇.<br />RAG와 LLM 기술로 정확성·확장성이 뛰어나며, 기업 내 FAQ 관리와 업무 지원을 혁신합니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my ai-business-wrap" ref={contentRef}>
        <section className="aiCont">
          <h4 className="title">
            <span>연관 솔루션</span>
          </h4>

          <h5 className="title">기업·기관의 비즈니스 프로세스를 혁신하세요!</h5>
          <p className="text">조직 내 모든 유형의 <span className="blue">AI 서비스와 데이터</span>를 손쉽게 연결하고, 통합된 환경에서 안전하게 운영·확장할 수 있는 엔터프라이즈 AI 허브이자, 업무 혁신의 디지털 플랫폼입니다.<br/>
          <span className="blue">복수의 AI 엔진, 멀티모달 데이터, 외부/기존 IT 시스템 및 다양한 채널</span>과의 연계를 필요로 하는 기업·기관에 특히 적합합니다.<br/>
          플랫폼 도입 시 즉각적 디지털 전환 효과와 <span className="blue">지속적 AI 확장 기반</span>을 함께 확보할 수 있습니다.</p>
          <ul className="link-wrap">
            <li> <Link to="/WISplatform">WISplatform <i></i></Link></li>
            <li> <Link to="/WISaicc">WISaicc <i></i></Link></li>
            <li> <Link to="/WISserch">WISsearch <i></i></Link></li>
            <li> <Link to="/WISvec">WISvec <i></i></Link></li>
            <li> <Link to="/WISrag">WISrag <i></i></Link></li>
            <li> <Link to="/WISdoc">WISdoc <i></i></Link></li>
            <li> <Link to="/WISscrap">WISscrap <i></i></Link></li>
            <li> <Link to="/WISocr">WISocr <i></i></Link></li>
            <li> <Link to="/WISvoice">WISvoice <i></i></Link></li>
            <li> <Link to="/WISvision">WISvision <i></i></Link></li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
          <span>WISbot 이란?</span>
        </h4>
        <div className="textWrap">
            <div className="ai-ci"><img src={aiImg} alt="WISbot" /></div>
            <div className="info">
              <p>WISbot은 Retrieval-Augmented Generation(RAG) 아키텍처와 대형 언어 모델(LLM)을 결합한 기업 맞춤형 생성형 챗봇 솔루션입니다. 기업의 내부 데이터, 사규, 정책, FAQ, 제품 매뉴얼 등 방대한 지식과 실시간 외부 정보를 연결하여, 정합성과 신뢰성이 뛰어난 답변을 자동 생성합니다.<br/>RAG 구조로 인해 단순 챗봇의 한계를 넘어,“실제 데이터 기반의 근거 있는 질의응답”이 가능한 고도화된 기업용 AI 비서입니다.</p>

              <ul className="list">
                <li>
                  <p className="tit">RAG 기반 실시간 질의응답</p>
                  <p className="txt">사용자의 질문에 대해 내부/외부 데이터에서 근거를 검색한 후, LLM이 맥락을 반영해 답변 생성</p>
                </li>
                 <li>
                  <p className="tit">기업 맞춤형 데이터 연동</p>
                  <p className="txt">사내 DB, 지식관리(KMS), 정책문서, 제품자료 등 다양한 기업자산 연계지원</p>
                </li>
                 <li>
                  <p className="tit">다채널·시나리오 챗봇 구현</p>
                  <p className="txt">사내 포털, 메신저, 모바일 등 여러 채널에서 동시에 운영 가능 업무별(IT 지원, HR, 법무, 고객응대 등) 맞춤형 대화 설계 </p>
                </li>
                <li>
                  <p className="tit">지속적 도메인 학습</p>
                  <p className="txt">기업 전용 토픽/용어로 LLM 파인튜닝 및 최신 지식 자동 학습</p>
                </li>
                <li>
                  <p className="tit">대화 분석·모니터링·관리툴</p>
                  <p className="txt">대화 이력, 답변 품질, 키워드/상황별 통계 리포트 업무 효율·이슈 탐지 등 경영정보 제공</p>
                </li>
                <li>
                  <p className="tit">할루시네이션(환각) 방지</p>
                  <p className="txt">답변이 실제 근거 데이터 안에서 생성되도록 구조화, 사실이 아닌 정보 답변(환각) 최소화</p>
                </li>
              </ul>
            </div>
        </div>
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>특장점</span>
          </h4>
          <ul className="textWrap feature-list">
            <li>
              <span className="icon"><img src={aiIcon01} alt="현장적용 속도와 생산성 증가"/></span>
              <p className="tit">현장적용 속도와<br/>생산성 증가</p>
              <p className="txt">업무별 챗봇 구현·확장이 빠르고 유연하여, 인력/운영 비용이 크게 절감</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon02} alt="지식/데이터 자산화"/></span>
              <p className="tit">지식/데이터<br/>자산화</p>
              <p className="txt">산재된 기업 지식과 데이터를 체계적으로 축적·연결</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon03} alt="운영 관리의 자동화"/></span>
              <p className="tit">운영 관리의<br />자동화</p>
              <p className="txt">모니터링, 통계, 품질 관리가 통합 제공되어 운영 효율 극대화</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon04} alt="신뢰성 강화"/></span>
              <p className="tit">신뢰성<br/>강화</p>
              <p className="txt">근거가 명확하고 최신 정보가 실시간 반영되는 AI 서비스로, 사용자 신뢰와 만족도 상승</p>
            </li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
            <span>아키텍처</span>
          </h4>
          <ul className="textWrap ac-list">
              <li>
                <p className="tit">사용자 질문 입력</p>
                <p className="txt">(사용자가 텍스트·음성등으로 질문 전송)</p>
              </li>
              <li>
                <p className="tit">전처리·질문 임베딩</p>
                <p className="txt">(질문 의미 분석 및 벡터화)</p>
              </li>
              <li>
                <p className="tit">유사도 기반 데이터 검색</p>
                <p className="txt">(벡터DB, 사내/외부 문서의 유사도 기반 청크 검색)</p>
              </li>
              <li>
                <p className="tit">RAG 프롬프트 생성</p>
                <p className="txt">(질문 + 검색된 근거 데이터를 LLM의 프롬프트로 결합)</p>
              </li>
              <li>
                <p className="tit">LLM 기반 답변 생성</p>
                <p className="txt">(실제 데이터에 근거한 맞춤형 답변 생성)</p>
              </li>
              <li>
                <p className="tit">챗봇 UI</p>
                <p className="txt">(웹, 모바일 등 다양한 채널에서 사용자에게 실시간 응답)</p>
              </li>
            </ul>
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>프레임워크</span>
          </h4>
          <div className="textWrap framework">
              <img src={fwImg} alt="WISbot 프레임워크" onClick={imgClick} />
          </div>
          
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>활용사례</span>
          </h4>
          <ul className="textWrap case-list">
              <li>
                <p className="tit">사내 HR·법무·회계·IT 컨시어지</p>
                <p className="txt">HR 정책, 인사규정, 시스템 매뉴얼 Q&A, 법무 지원, 회계 지원, 기술 가이드봇</p>
              </li>
                <li>
                <p className="tit">고객지원 및 FAQ 자동화</p>
                <p className="txt">고객 문의, AS, 서비스/상품 정보 안내, 실시간 FAQ 답변</p>
              </li>
                <li>
                <p className="tit">제품/매뉴얼 기반 전문가 챗봇</p>
                <p className="txt">사용설명서, 기술문서 등에서 답변 근거를 함께 제시하는 전문 응대</p>
              </li>
                <li>
                <p className="tit">교육/학습</p>
                <p className="txt">사내 규정, 업무 프로세스, 문서 검색 기반 교육 챗봇</p>
              </li>
          </ul>
          
        </section>

        <section className="aiCont">
          <div className="btnWrap">
            <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
            {/* <button type="button" className="inquiry-btn" onClick={pdfDownload}>pdf테스트</button> */}
          </div>
        </section>
        
			</section>
		</main>
	<Footer />

        </>
    )
}

export default WISbot;